import * as React from 'react';
import { SVGProps } from 'react';

const IconMoonSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10.737 7.604a4 4 0 0 1-4.396-6.593 5 5 0 1 0 4.396 6.593z" />
  </svg>
);
export default IconMoonSizeXs;
